import React, {FunctionComponent} from 'react';
import styles from './dropdown.module.scss';
import {useTranslation} from 'react-i18next';
import {conditionalClassLister} from '../../utils/class-helpers';

const DropdownComponent: FunctionComponent<OwnProps> = (props: OwnProps) => {
    const {t} = useTranslation();
    const {options, width, onSelectionChanged, selectedOptionValue, invalid, allowUnknown = false, addRanking = false} = props;

    const panelClasses = conditionalClassLister(styles)({
        selectionPanel: true,
        invalid: invalid,
    });

    return (
        <div className={styles.dropdownPanel}
             style={width ? {width} : {}}>
            <select className={panelClasses} value={selectedOptionValue || 'placeholder'} onChange={(e) => onSelectionChanged(e.target.value)}>
                <option className={styles.hiddenOption} key={'placeholder'} value={'placeholder'} disabled>{t('Pick an option')}</option>
                {options.map((option, index) =>
                    <option key={option.key ? option.key : option.value} value={option.value}>{addRanking ? (`(${options.length - index - 1})`) : ''} {option.label}</option>)}
                {allowUnknown ? <option key={'unknown'} value={'unknown'}>{t('Unknown')}</option> : null}
            </select>
        </div>
    );
}
export default DropdownComponent;

interface OwnProps {
    options: SelectionOption[];
    onSelectionChanged: (value: string) => void;
    selectedOptionValue?: string | number;
    width?: string;
    disabled?: boolean;
    allowUnknown?: boolean;
    addRanking?: boolean;
    invalid?: boolean;
}

export interface SelectionOption {
    value?: string;
    label: string;
    key?: string;
    category?: SelectionOptionCategory;
}

export interface SelectionOptionCategory {
    key: string;
    label: string;
    index: number;
}
